import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { SharedService } from '../services/shared/shared.service';

export const loginGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const sharedService = inject(SharedService);
  const router = inject(Router);

  if (!sharedService.token) {
    return true;
  } else {
    router.navigate(['/home']);
    return false;
  }
};
